<a
    *appHasPermissionId="permissionList.teamRead; else justNameTemplateRef"
    [routerLink]="['', 'team', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
